/**
 * @generated SignedSource<<ee5e295623c029160e911e4ed94bb59f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItems_navItem$data = {
  readonly dataTn: string | null;
  readonly eventName: string | null;
  readonly items?: ReadonlyArray<{
    readonly title: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_navItem">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_navItem">;
  readonly " $fragmentType": "NavExpandingAreaItems_navItem";
};
export type NavExpandingAreaItems_navItem$key = {
  readonly " $data"?: NavExpandingAreaItems_navItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_navItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItems_navItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_navItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataTn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventName",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarListItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavExpandingAreaItem_navItem"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "NavBarList",
      "abstractKey": null
    }
  ],
  "type": "NavBarElement",
  "abstractKey": "__isNavBarElement"
};

(node as any).hash = "f1362cc30de3f6c8b07d45256f2d518a";

export default node;
